import {FINDER_OVERVIEW_SET_SCHEMA} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} dataContext
 * @param {Schema} schema
 *
 * @return {void}
 */
const setSchema = ( panelKey : string, dataContext: string, schema : Schema ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: FINDER_OVERVIEW_SET_SCHEMA,
        panelKey,
        dataContext,
        schema
    } );

    // clear global data
    global.data[ dataContext ] = {
        items     : {},
        references: {},
        schema
    };

    dispatch( clearElusiveData( panelKey ) );
}
export type SetSchema = typeof setSchema;

export default setSchema;
